import React from 'react';
import { Building2 } from 'lucide-react';
interface MobileHeaderProps {
  selectedSite: string | null;
}
export function MobileHeader({
  selectedSite
}: MobileHeaderProps) {
  return <header className="bg-white border-b border-gray-200 p-4 safe-area-pt" data-id="element-8">
      <div className="flex items-center justify-between" data-id="element-9">
        <div className="flex items-center space-x-3" data-id="element-10">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8TqFKdC4LW2Hc8J9kPHYEt/Sans_titre_9.png" alt="Action Progex" className="h-8" data-id="element-11" />
        </div>
        {selectedSite && <div className="flex items-center space-x-2 text-sm" data-id="element-12">
            <Building2 size={16} className="text-gray-600" data-id="element-13" />
            <span className="font-medium text-gray-900" data-id="element-14">{selectedSite}</span>
          </div>}
      </div>
    </header>;
}